// import id from "date-fns/locale/id/index.js";
import { csrfFetch } from "./csrf.js";

const SET_GORDER = 'gorder/setGOrder';
const REMOVE_GORDER = "gorder/removeGOrder";
const SET_GORDERS = 'gorder/setGOrders';
const SET_GORDERS_WITH_GWORKORDERS = "gorder/setGOrdersWithGWorkOrders";

const setGOrder = (gorder) => ({
  type: SET_GORDER,
  payload: gorder,
});

const removeGOrder = () => ({
  type: REMOVE_GORDER,
});

const setGOrders = (gorders) => ({
  type: SET_GORDERS,
  payload: gorders,
});

const setGOrdersWithGWorkOrders = (gordersWithGWorkOrders) => ({
  type: SET_GORDERS_WITH_GWORKORDERS,
  payload: gordersWithGWorkOrders,
});

export const create = ({
  id,
  orderNo,
  gprojectId,
  receiver,
  site,
  inChargeNameGclient,
  inChargePhoneGclient,
  // inChargeEmailGclient,
  deliveryAddress,
  orderDate,
  deliveryDate,
  // owner,
  ordererName,
  ordererPhone,
  ordererEmail,
  comments,
  gorderDetails,
  sumAmount,
  sumAreaMeter,
  sumAreaJa,
  sumAreaFeet,
  sumOrderPriceTotal,
}) => async dispatch => {
  const response = await csrfFetch(dispatch, "/api/gorders", {
    method: "POST",
    body: JSON.stringify({
      id,
      orderNo,
      gprojectId,
      receiver,
      site,
      inChargeNameGclient,
      inChargePhoneGclient,
      // inChargeEmailGclient,
      deliveryAddress,
      orderDate,
      deliveryDate,
      // owner,
      ordererName,
      ordererPhone,
      ordererEmail,
      comments,
      gorderDetails,
      sumAmount,
      sumAreaMeter,
      sumAreaJa,
      sumAreaFeet,
      sumOrderPriceTotal,
    }),
  });
  const data = await response.json();
  dispatch(setGOrder(data.gorder));
  return response;
};

export const modify = ({
  id,
  orderSerialNo,
  orderNo,
  gprojectId,
  receiver,
  site,
  inChargeNameGclient,
  inChargePhoneGclient,
  // inChargeEmailGclient,
  deliveryAddress,
  orderDate,
  deliveryDate,
  // owner,
  ordererName,
  ordererPhone,
  ordererEmail,
  comments,
  gorderDetails,
  sumAmount,
  sumAreaMeter,
  sumAreaJa,
  sumAreaFeet,
  sumOrderPriceTotal
}) => async dispatch => {
  const response = await csrfFetch(dispatch, "/api/gorders", {
    method: "PUT",
    body: JSON.stringify({
      id,
      orderSerialNo,
      orderNo,
      gprojectId,
      receiver,
      site,
      inChargeNameGclient,
      inChargePhoneGclient,
      // inChargeEmailGclient,
      deliveryAddress,
      orderDate,
      deliveryDate,
      // owner,
      ordererName,
      ordererPhone,
      ordererEmail,
      comments,
      gorderDetails,
      sumAmount,
      sumAreaMeter,
      sumAreaJa,
      sumAreaFeet,
      sumOrderPriceTotal
    }),
  });
  const data = await response.json();
  dispatch(setGOrder(data.gorder));
  return response;
};

export const selectAll = () => async dispatch => {
  const response = await csrfFetch(dispatch, "/api/gorders");
  const data = await response.json();
  dispatch(setGOrders(data.gorders));
  return response;
}

export const selectAllByQuery = () => async dispatch => {
  const response = await csrfFetch(dispatch, "/api/gorders/query/selectAll");
  const data = await response.json();
  dispatch(setGOrders(data.gorders));
  return response;
}

export const selectAllByProjectByQuery = (gprojectId) => async dispatch => {
  const response = await csrfFetch(dispatch, `/api/gorders/query/selectAll/porject/${gprojectId}`);
  const data = await response.json();
  dispatch(setGOrders(data.gorders));
  return response;
}

export const selectAllByStatusByQuery = (statusArray) => async dispatch => {
  const response = await csrfFetch(dispatch, "/api/gorders/query/selectAll/statusArray", {
    method: "POST",
    body: JSON.stringify({ statusArray }),
  });
  const data = await response.json();
  dispatch(setGOrders(data.gorders));
  return response;
}

export const selectAllByStatusReceptionByQuery = (statusReceptionArray) => async dispatch => {
  const response = await csrfFetch(dispatch, "/api/gorders/query/selectAll/statusReceptionArray", {
    method: "POST",
    body: JSON.stringify({ statusReceptionArray }),
  });
  const data = await response.json();
  dispatch(setGOrders(data.gorders));
  return response;
}

// TODO : 아래와 같이 업무로직이 세분화된 쿼리의 경우 redux를 사용해야 하는지 검토 필요
// 접수된 주문중 작업의뢰가 내려가지 않은 목록
export const selectGReceptionsNoWorkOrder = (statusArray) => async dispatch => {
  const response = await csrfFetch(dispatch, `/api/gorders/query/selectGReceptionsNoWorkOrder`);
  const data = await response.json();
  dispatch(setGOrders(data.gorders));
  return response;
}

export const select = (id) => async dispatch => {
  const response = await csrfFetch(dispatch, `/api/gorders/${id}`);
  const data = await response.json();
  dispatch(setGOrder(data.gorder));
  return response;
}

export const selectByQuery = (id) => async dispatch => {
  const response = await csrfFetch(dispatch, `/api/gorders/query/select/${id}`);
  const data = await response.json();
  dispatch(setGOrder(data.gorder));
  return response;
}

export const selectDirect = async (id) => {
  const response = await csrfFetch(null, `/api/gorders/${id}`);
  const data = await response.json();
  return data.gorder;
}

export const selectByQueryDirect = async (id) => {
  const response = await csrfFetch(null, `/api/gorders/query/select/${id}`);
  const data = await response.json();
  return data.gorder;
}

export const selectAllWithGWorkOrdersByQuery = () => async dispatch => {
  const response = await csrfFetch(dispatch, "/api/gorders/query/selectAllWithGWorkOrders");
  const data = await response.json();
  dispatch(setGOrdersWithGWorkOrders(data.gordersWithGWorkOrders));
  return response;
}

export const initGOrder = () => async dispatch => {
  dispatch(setGOrder(null));
  // dispatch(setGOrder({}));
}

// 목록에서 선택해서 다이얼로그를 띄우거나 목록에서 등록하기를 누를 때
// 다이얼로그에서는 선택한 행 데이터의 변화를 감지하여 선택 데이터 혹은 초기화 데이터로 화면을 구성하는데
// 위의 initGOrder처럼 null로 세팅하면 이후 null일 때(등록하기를 연속 누른 경우) 변화감지 X
// 아래처럼 초기값을 줄 경우 변화감지 O (빈 객체 {} 일 경우도 바뀐 것으로 간주)
export const initGOrderWithInitialValue = (gorder) => async dispatch => {
  dispatch(setGOrder(gorder));
}

/**
 *                           status        statusReception       statusWorkOrder
 * 발주생성                   WRITING      null                  null
 * 발주전송                   SEND          PRE-RECEIVE           null
 * 수주접수                   RECEIVE       RECEIVE               PRE
 * 수주반송                   RETURN        RETURN                null                (반송된 수주내용을 수정하여 다시 전송하는데 수정시는 계속 'RETURN' 상태임 => 목록에서 '반송' 상태)
 * 작업의뢰(일부발행)          RECEIVE       RECEIVE               ING
 * 작업의뢰(발행완료)          RECEIVE       RECEIVE               DONE
 */
export const send = ({ id, status, comments }) => async dispatch => {
  const response = await csrfFetch(dispatch, "/api/gorders/status", {
    method: "PUT",
    body: JSON.stringify({ id, status, statusReception: "PRE-RECEIVE", comments }),
  });
  const data = await response.json();
  dispatch(setGOrder(data.gorder));
  return response;
};

export const sendDirect = async ({ id, status, comments }) => {
  const response = await csrfFetch(null, "/api/gorders/status", {
    method: "PUT",
    body: JSON.stringify({ id, status, statusReception: "PRE-RECEIVE", comments }),
  });
  const data = await response.json();
  return data.gorder;
};

export const receive = ({ id, statusReception, comments }) => async dispatch => {
  const response = await csrfFetch(dispatch, "/api/gorders/status", {
    method: "PUT",
    body: JSON.stringify({ id, status: statusReception, statusReception, statusWorkOrder: statusReception === "RECEIVE" ? "PRE" : null, comments }),
  });
  const data = await response.json();
  dispatch(setGOrder(data.gorder));
  return response;
};

export const receiveDirect = async ({ id, statusReception, comments }) => {
  const response = await csrfFetch(null, "/api/gorders/status", {
    method: "PUT",
    body: JSON.stringify({ id, status: statusReception, statusReception, statusWorkOrder: statusReception === "RECEIVE" ?  "PRE" : null, comments }),
  });
  const data = await response.json();
  return data.gorder;
};

export const setStatusWorkOrder = ({ id, statusWorkOrder, comments }) => async dispatch => {
  const response = await csrfFetch(dispatch, "/api/gorders/status", {
    method: "PUT",
    body: JSON.stringify({ id, statusWorkOrder, comments }),
  });
  const data = await response.json();
  dispatch(setGOrder(data.gorder));
  return response;
};

export const remove = (id) => async (dispatch) => {
  const response = await csrfFetch(dispatch, `/api/gorders/${id}`, {
    method: "DELETE",
  });
  dispatch(removeGOrder());
  return response;
};

export const reorder = async ({ type, id }) => {
  const response = await csrfFetch(null, "/api/gorders/reorder", {
    method: "POST",
    body: JSON.stringify({ type, id }),
  });
  
  return response;
}

export const selectAllByProject = (gprojectId) => async dispatch => {
  const response = await csrfFetch(dispatch, `/api/gorders/project/${gprojectId}`);
  const data = await response.json();
  dispatch(setGOrders(data.gorders));
  return response;
}

export const selectAllByProjectByDirect = async (gprojectId) => {
  const response = await csrfFetch(null, `/api/gorders/project/${gprojectId}`);
  const data = await response.json();
  return data;
}

const initialState = {
  gorder: null,
  gorders: [],
  gordersWithGWorkOrders: [],
};

function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_GORDER:
      newState = Object.assign({}, state, { gorder: action.payload });
      return newState;
    case REMOVE_GORDER:
      newState = Object.assign({}, state, { gorder: null });
      return newState;
    case SET_GORDERS:
      newState = Object.assign({}, state, { gorders: action.payload });
      return newState;
    case SET_GORDERS_WITH_GWORKORDERS:
      newState = Object.assign({}, state, { gordersWithGWorkOrders: action.payload });
      return newState;
    default:
      return state;
  }
}

export default reducer;
